module.exports = __webpack_public_path__ + "img/withdraw-fail.cef7fe80.png";